import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as GC from '../../constants';
//////////////////////////////////////////////////

const store = (state) => state.notifications;
const configStore = (state) => state.config;

const makeSelectItemList = () => createSelector(
  store,
  (state) => R.sortBy(
    R.prop('index'),
    R.values(state.itemList),
  ),
);

const makeSelectPagination = () => createSelector(
  store,
  (state) => state.pagination,
);

const makeSelectWsCount = () => createSelector(
  store,
  (state) => state.wsCount,
);

const makeSelectUnreadCount = () => createSelector(
  store,
  (state) => state.unreadCount,
);

const makeSelectTotalCount = () => createSelector(
  store,
  (state) => state.totalCount,
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectGeneralConfig = () => createSelector(
  configStore,
  ({ general }) => (R.path(['initialValues', GC.GENERAL_UOM_CALC_DEFAULT_UOM_SYSTEM], general)),
);

export {
  makeSelectWsCount,
  makeSelectItemList,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectUnreadCount,
  makeSelectListLoading,
  makeSelectGeneralConfig,
};
